export enum PaperExtraType {
  Colored,
  Lamination,
  Binding,
  Frame,
}
